import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Search } from "lucide-react";
import { formatET } from "@/lib/dates";

const ACTION_COLORS = {
  login: "bg-blue-500/20 text-blue-400", lead_create: "bg-emerald-500/20 text-emerald-400",
  lead_status_change: "bg-amber-500/20 text-amber-400", lead_delete: "bg-red-500/20 text-red-400",
  contract_send: "bg-violet-500/20 text-violet-400", contract_sign: "bg-green-500/20 text-green-400",
  mark_paid: "bg-green-500/20 text-green-400", employee_create: "bg-cyan-500/20 text-cyan-400",
  employee_update: "bg-cyan-500/20 text-cyan-400", calendar_block: "bg-orange-500/20 text-orange-400",
  password_change: "bg-rose-500/20 text-rose-400", password_reset: "bg-rose-500/20 text-rose-400",
  inquiry_submit: "bg-blue-500/20 text-blue-400", reservation_release: "bg-yellow-500/20 text-yellow-400",
  cancel_booking: "bg-red-500/20 text-red-400", refund: "bg-orange-500/20 text-orange-400",
  email_sent: "bg-emerald-500/20 text-emerald-400", mass_blast: "bg-purple-500/20 text-purple-400",
  template_create: "bg-violet-500/20 text-violet-400",
};

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/audit")
      .then(({ data }) => setLogs(data.logs))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = logs.filter(l =>
    `${l.action} ${l.username} ${l.details}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-4" data-testid="audit-log-page">
      <h1 className="font-outfit text-2xl font-bold tracking-tight">Audit Log</h1>
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="audit-search" placeholder="Search logs..." className="pl-9" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>
      {loading ? (
        <div className="space-y-2">{Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-12 w-full" />)}</div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">No logs found</div>
      ) : (
        <div className="space-y-1.5">
          {filtered.map((log) => (
            <Card key={log.id} className="border-border">
              <CardContent className="p-3 flex items-center gap-3">
                <Badge className={`text-xs shrink-0 ${ACTION_COLORS[log.action] || "bg-muted text-muted-foreground"}`}>
                  {log.action?.replace(/_/g, " ")}
                </Badge>
                <div className="min-w-0 flex-1">
                  <span className="text-sm font-medium">{log.username}</span>
                  {log.details && <span className="text-sm text-muted-foreground ml-2">{log.details}</span>}
                </div>
                <span className="text-xs text-muted-foreground shrink-0">{formatET(log.timestamp)}</span>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
